/**
 * Point d'entrée — monte le shell applicatif (rail de modes, workspaces,
 * panneau résultat/historique) et démarre le polling de statut.
 */
import { resumePendingJob } from "./services/execution.js";
import { Shell } from "./shell/Shell.js";
import { WORKSPACES } from "./workspaces/index.js";

const root = document.getElementById("app");
if (!root) throw new Error("#app introuvable dans index.html");

const shell = new Shell(WORKSPACES);
root.appendChild(shell.element);
shell.start();

// Une page qui se recharge pendant une génération ne doit pas perdre son
// résultat : le job vit côté serveur, on va le rechercher. Sur un téléphone
// c'est le cas normal, pas l'exception — quatre minutes d'attente, c'est un
// écran qui se verrouille.
void resumePendingJob();

// Exposé pour les phases suivantes (workspace Compte : zone utilisateur,
// panneau résultat : actions upscale/détourage, …).
export { shell };
